<ng-container *transloco="let t">
  @if (
    {
      activeLang: activeLang$ | async,
      errorMessage: errorMessage$ | async,
      readOnly: readOnly$ | async,
    };
    as data
  ) {
    <div class="form-group question-container-inner" [formGroup]="questionForm">
      <lib-input-container
        [headLine]="
          question.translations?.list['headLine']
            | translate: data.activeLang : question.structure.headLine
        "
        [description]="
          question.translations?.list['description']
            | translate: data.activeLang : question.structure.description
        "
        [labelPrefix]="questionNumber$ | async"
        [label]="
          question.translations?.list['title']
            | translate: data.activeLang : question.title
        "
        [questionMarkText]="
          question.translations?.list['questionMarkText']
            | translate: data.activeLang : question.structure.questionMarkText
        "
        [required]="question.validation.required"
        [maxLength]="question.validation.maxLength"
        [errorText]="data.errorMessage"
        [currentLength]="value.value ? value.value.toString().length : 0"
        [for]="labelPrefix + question.id"
        [inputType]="inputType"
        [autoWidth]="true"
        [helpText]="
          question.translations?.list['helpText']
            | translate: data.activeLang : question.structure.helpText
        "
        [showChangeIndicator]="
          !data.readOnly &&
          showChanges() &&
          previousAnswersService.hasSimpleValueChanged(
            question.id,
            repeaterGroupId,
            value.value
          )
        "
      >
        @if (!data.readOnly) {
          @if (inputType !== InputType.Phone) {
            <input
              vinnova-text-input
              [id]="labelPrefix + question.id"
              [error]="data.errorMessage"
              [required]="question.validation.required"
              formControlName="value"
              [placeholder]="question.structure.placeholder"
              [inputType]="inputType"
              [suffix]="suffixSymbol"
            />
          } @else {
            <lib-text-input-phone
              formControlName="value"
              [error]="data.errorMessage"
              [id]="labelPrefix + question.id"
            ></lib-text-input-phone>
          }
        }
        @if (data.readOnly) {
          <div
            [ngClass]="
              inputType === InputType.Number ||
              inputType === InputType.Amount ||
              inputType === InputType.Percent
                ? 'numeric'
                : ''
            "
          >
            @if (readonlyValue()) {
              <div class="readonly">
                {{ readonlyValue() }}
                @if (inputType !== InputType.Phone) {
                  <span class="suffix">{{ suffixSymbol }}</span>
                }
              </div>
            } @else {
              <div
                class="readonly"
                [ngClass]="data.errorMessage ? 'invalid' : ''"
              >
                <span class="suffix">{{ suffixSymbol }}</span>
              </div>
            }
          </div>
        }
      </lib-input-container>
    </div>
  }
</ng-container>
